import { useRoutes } from 'react-router-dom';

import { commonRoutes } from './common';
import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

type Props = {
  isAuthenticated: boolean;
};

export const AppRoutes = ({ isAuthenticated }: Props) => {
  const routes = (isAuthenticated ? protectedRoutes : publicRoutes).concat(commonRoutes);

  const element = useRoutes([...routes]);

  return <>{element}</>;
};
